// import "web-animations-js/web-animations-next.min.js"; //v2.3.1 as git is not well maintained
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

// const fixIdScrolling = {
//   watch: {
//     $route(to, from) {
//       const currentRoute = this.$router.currentRoute;
//       const idToScrollTo = currentRoute.hash;
//       this.$nextTick(() => {
//         if (idToScrollTo && document.querySelector(idToScrollTo)) {
//           document
//             .querySelector(idToScrollTo)
//             .scrollIntoView({ behhavior: "smooth" });
//         }
//       });
//     }
//   }
// };

// const projectList = projects.Projects;
// // let data = {
// //   projectsJson: projectList
// // };

// Vue.mixin({
//   data: function() {
//     return {
//       projectsJson: projectList
//     };
//   }
// });

Vue.directive("scrollIn", {
  inserted: function(el, anim) {
    let f = function(evt) {
      var hasRun = false;
      let rect = el.getBoundingClientRect();
      if (!hasRun && window.scrollY > rect.top) {
        hasRun = true;
        anim();
      }
      if (window.scrollY > rect.bottom) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

new Vue({
  // data: data,
  // mixins: [fixIdScrolling],
  router,
  store,
  render: h => h(App)
}).$mount("#app");
